import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationWrapper, Box, TextWrapper, NoRecordFound } from './NotificationStyled'
import { useHistory } from 'react-router-dom';
import ClearIcon from '@material-ui/icons/Clear';
import mixed_Arrow from 'web/assets/images/mixed_Arrow.gif';
import { notificationMarkReadApiV2, notificationClearApiV2 } from 'redux/actions/notification';
import AlertModal from 'web/components/AlertModal';
import Spinner from "web/components/Spinner";

const NotificationBox = ({ notificationPageData, notificationPageDataInfo, ...props }) => {
  let history = useHistory();
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const [loader, setLoader] = useState(false)
  const [page, setPage] = useState(1);
  const token = localStorage.getItem('token');
  const [pageDisplayData, setPageDisplayData] = useState([]);
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const notificationWrapperRef = useRef(null);

  const orderPagePendingTabRedirectEnums = ['ORDER_ASSIGNED', 'ORDER_COMPLETED', 'ORDER_CLAIM'];

  useEffect(() => {
    setPageDisplayData(notificationPageData)
  }, [notificationPageData])

  useEffect(() => {
    if (notificationPageDataInfo === 'pageResetToOne' && notificationWrapperRef.current) {
      notificationWrapperRef.current.scrollTop = 0;
    }
  }, [notificationPageDataInfo]);

  const notificationClickFunction = async (items) => {
    let data = {
      notificationId: items.notificationId,
    }
    dispatch(notificationMarkReadApiV2(data, token))
    // redirection to the corresponding page
    if (items.redirectEnum === 'POSTED_NEED') history.push('/my-posted-pallet-needs')
    else if (items.redirectEnum === 'POSTED_INVENTORY') history.push('/my-posted-pallet-inventory')
    else if (items.redirectEnum === 'POST_NEED_DETAILS') history.push(`/details?id=${items?.actionId}&postType=PostLoad`)
    else if (items.redirectEnum === 'POST_INVENTORY_DETAILS') history.push(`/details?id=${items?.actionId}&postType=PostInventory`)
    else if (items.redirectEnum === 'MY_BIDS') history.push('/view-my-bids-on-pallet-needs')
    else if (items.redirectEnum === 'MY_OFFERS') history.push('/view-my-offers-on-pallet-inventory')
    else if (items.redirectEnum === 'DELIVERY_ORDER_PENDING' || items.redirectEnum === 'DELIVERY_DECLINED') {
      let myOrderSelectedPageObj = { myOrderSelectedPage: 1, }
      dispatch({ type: 'MYORDER_PAGINATION', payload: myOrderSelectedPageObj })
      let obj = { pageType: "MyOrder", expanded: "sideBar" }
      dispatch({ type: 'ORDERS', payload: obj })
      history.push('/my-orders')
    } else if (orderPagePendingTabRedirectEnums.includes(items.redirectEnum)) {
      let myOrderSelectedPageObj = { myOrderSelectedPage: 1, }
      dispatch({ type: 'MYORDER_PAGINATION', payload: myOrderSelectedPageObj })
      let obj = { selectedTab: "PENDING", expanded: "sideBar" }
      dispatch({ type: 'ORDERS', payload: obj })
      history.push('/my-orders')
    } else if (items.redirectEnum === 'ORDER_DELIVERED') {
      let myOrderSelectedPageObj = { myOrderSelectedPage: 1, }
      dispatch({ type: 'MYORDER_PAGINATION', payload: myOrderSelectedPageObj })
      let obj = { selectedTab: "DELIVERED", expanded: "sideBar" }
      dispatch({ type: 'ORDERS', payload: obj })
      history.push('/my-orders')
    } else if (items.redirectEnum === 'ORDER_CANCELLED') {
      let myOrderSelectedPageObj = { myOrderSelectedPage: 1, }
      dispatch({ type: 'MYORDER_PAGINATION', payload: myOrderSelectedPageObj })
      let obj = { selectedTab: "CANCELLED", expanded: "sideBar" }
      dispatch({ type: 'ORDERS', payload: obj })
      history.push('/my-orders')
    } else if (items.redirectEnum === 'COMMUNITY_GROUP') {
      let obj = { selectedTab: "joined", expanded: "sideBar", }
      dispatch({ type: 'MYCOMMUNITY', payload: obj })
      history.push('/my-community')
    } else if (items.redirectEnum === 'COMMUNITY_INVITE') {
      let obj = { selectedTab: "invite", expanded: "sideBar", }
      dispatch({ type: 'MYCOMMUNITY', payload: obj })
      history.push('/my-community')
    } else if (items.redirectEnum === 'CLAIM_RAISED') {
      let obj = { selectedTab: "CLAIM_DETAILS", expanded: "sideBar" }
      dispatch({ type: 'RESOLUTION_CENTER', payload: obj })
      history.push('/resolution-center')
    } else if (items.redirectEnum === 'CLAIM_RECEIVED') {
      let obj = { selectedTab: "CLAIM_DETAILS", expanded: "sideBar" }
      dispatch({ type: 'RESOLUTION_CENTER', payload: obj })
      history.push('/resolution-center')
    } else if (items.redirectEnum === 'CLAIM_RESOLVED') {
      let obj = { selectedTab: "RESOLVED", expanded: "sideBar" }
      dispatch({ type: 'RESOLUTION_CENTER', payload: obj })
      history.push('/resolution-center')
    } else if (items.redirectEnum === 'CLAIM_ESCALATED') {
      let obj = { selectedTab: "CLAIM_REJECTED", expanded: "sideBar" }
      dispatch({ type: 'RESOLUTION_CENTER', payload: obj })
      history.push('/resolution-center')
    } else if (items.redirectEnum === 'PICKUP_PENDING') {
      localStorage.setItem('redirectPickupOrderTabValue', 0)
      history.push('/my-pickup-orders')
    } else if (items.redirectEnum === 'PICKUP_ASSIGNED') {
      localStorage.setItem('redirectPickupOrderTabValue', 1)
      history.push('/my-pickup-orders')
    } else if (items.redirectEnum === 'PICKEDUP') {
      localStorage.setItem('redirectPickupOrderTabValue', 2)
      history.push('/my-pickup-orders')
    } else if (items.redirectEnum === 'PICKUP_ORDER_COMPLETE') {
      localStorage.setItem('redirectPickupOrderTabValue', 3)
      history.push('/my-pickup-orders')
    } else if (items.redirectEnum === 'PICKUP_CANCLELLED') {
      localStorage.setItem('redirectPickupOrderTabValue', 4)
      history.push('/my-pickup-orders')
    } else if (items.redirectEnum === 'PICKUP_ORDER_CLAIM') {
      localStorage.setItem('redirectPickupOrderTabValue', 5)
      history.push('/my-pickup-orders')
    } else if (items.redirectEnum === 'PTPLUS_PENDING') {
      history.push('/ptplus-order-details')
    }
  }

  const notificationClearFunction = async (items) => {
    setLoader(true)
    let data = {
      notificationId: items.notificationId,
      actionType: items.actionType,
      requestType: null
    }
    await dispatch(notificationClearApiV2(data, token))
    setLoader(false)
    let currentDisplayData = JSON.parse(JSON.stringify(pageDisplayData))
    currentDisplayData = currentDisplayData.filter(data => data.notificationId !== items.notificationId)
    setPageDisplayData(currentDisplayData)
  }

  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (notificationPageDataInfo === 'endOfResults') {
      if (page !== 1) setPage(prevPage => prevPage - 1);
    } else if (scrollHeight - scrollTop <= clientHeight * 1.2 && !loaderVisible) {
      if (notificationPageDataInfo === 'pageResetToOne') {
        setPage(2);
        props.fetchDataCallBack(2);
      } else {
        setPage(prevPage => prevPage + 1);
        props.fetchDataCallBack(page + 1);
      }
    }
  };

  return (
    <NotificationWrapper>
      {loader && <Spinner />}
      <div ref={notificationWrapperRef} className='notification-box-wrapper' onScroll={handleScroll}>
        {pageDisplayData?.length > 0 ?
          <>
            {pageDisplayData?.map((items, index) => (
              <Box key={items.id} style={{ background: items.read ? '' : 'aliceblue' }} >
                {!items.read ? <span className='dot' style={{ marginTop: "0.6%" }}></span> : <span className='dot' style={{}}></span>}
                <div >
                  <TextWrapper>
                    <div style={{ marginTop: "1%" }} onClick={() => notificationClickFunction(items)}>
                      <h4>{items.notification}</h4>
                    </div>
                  </TextWrapper>
                  <div style={{ marginLeft: "25px" }}>
                    <span className='clear-icon' onClick={() => notificationClearFunction(items)}>
                      <ClearIcon />
                    </span>
                  </div>
                </div>
              </Box>
            ))}
            {loaderVisible && <div style={{ textAlign: "center", marginTop: "20px" }}>
              <img src={mixed_Arrow} alt='loader' style={{ width: '40px' }} />
            </div>}
          </> :
          <NoRecordFound>{!loaderVisible ? 'No records found' : <img src={mixed_Arrow} alt='loader' style={{ width: '40px' }} />}</NoRecordFound>}
      </div>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
      />
    </NotificationWrapper>
  )
};

export default NotificationBox;
